const ModuleType = {
  BILLING: "billing",
  CUSTOMER: "customer",
  USER: "user",
  PERMISSION: "permission",
  SCHEME: "scheme",
  APPROVALS: "approval",
  WORKFLOW: "workflow",
  PLEDGE_RELEASE_CASE: "pledgeReleaseCase",
  BRANCHES: "branches",
  WALK_IN_CASE: "walkInCase",
  GOLD_INVENTORY: "goldInventory",
  SMELTER: "smelter",
  FINANCIALS: "financials",
  DASHBOARD: "dashboard",
  SMM: "smm",
  SYSTEM: "system",
};

export default ModuleType;
